import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
} from "@mui/material";
import React, { useEffect, useContext } from "react";
import { SoecoButton } from "./SoecoButton";
import { Endpoint, imagesUrl, setEndpoint } from "../services/endpoints";
import { RowWrapper } from "../pages/EditProductPage/EditProduct";
import { post } from "../services/restClient";
import { useNavigate } from "react-router-dom";
import { useSnackBar } from "../context/SnackbarContext";
import { Company, Inventory, Product } from "../types";
import ChairAltIcon from "@mui/icons-material/ChairAlt";
import { EmployeeContext } from "../context/EmployeeContext";
import { useGetEmployee } from "../hooks/employeeHooks";
const AddEmailDialog = ({
    isAddEmailDialogOpen,
    handleCloseAddEmailDialog,
    products,
    inventories,
    companies,
}: {
    isAddEmailDialogOpen: boolean;
    handleCloseAddEmailDialog: () => void;
    setNewEmail: React.Dispatch<React.SetStateAction<string>>;
    products: Product[];
    inventories: Inventory[];
    companies: Company[];
}) => {
    const navigate = useNavigate();
    const snackBar = useSnackBar();
    const { employee } = useContext(EmployeeContext);
    const employeeQuery = useGetEmployee(employee.companyId, employee.id);
    const [productsWithEmail, setProductsWithEmail] = React.useState<Product[]>([]);

    useEffect(() => {
        const filterP = products.filter((product: Product) => {
            const inventory = inventories?.find(inv => inv.id === product.inventoryId);
            const company = companies?.find(comp => comp.id === product.companyId);

            const inventoryEmails = inventory?.emailaddresses ?? [];
            const companyEmails = company?.emailaddresses ?? [];

            const inventoryHasEmails = inventoryEmails.length > 0;
            const companyHasEmails = companyEmails.length > 0;

            return inventoryHasEmails || (!inventoryHasEmails && companyHasEmails);
        });

        setProductsWithEmail(filterP);
    }, [products, companies, inventories]);

    const handleSendEmail = (email: string, product: Product) => {
        // event.preventDefault();
        // if (!token) {
        //     return;
        // }
        // if (!isValidForm()) {
        //     return;
        // }

        type RequestBody = {
            email: string;
            product: Product;
            toEmails: string[];
        };

        type ResponseBody = RequestBody & {
            message: string;
        };

        const inventory = inventories?.find(inv => inv.id === product.inventoryId);
        const company = companies?.find(comp => comp.id === product.companyId);

        let toEmails: string[] = inventory?.emailaddresses || [];

        if (toEmails.length === 0) {
            toEmails = company?.emailaddresses || [];
        }

        post<RequestBody, ResponseBody>(setEndpoint(Endpoint.registerInterest), {
            email,
            product,
            toEmails,
        })
            .then(() => {
                snackBar.showSnackBar("Email sent successfully", "success");
            })
            .catch(error => {
                if (error instanceof Error) {
                    snackBar.showSnackBar(error.message, "error");
                }
            });
    };
    const companyMap = Object.fromEntries(companies.map(c => [c.id, c.name]));
    const inventoryMap = Object.fromEntries(inventories.map(i => [i.id, i.name]));

    return (
        <Dialog fullScreen open={isAddEmailDialogOpen} onClose={handleCloseAddEmailDialog}>
            <DialogTitle>Send emails to register interest in products</DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>
                    {productsWithEmail.length > 0 ? (
                        productsWithEmail.map((product: Product) => (
                            <Grid item key={product.id} xs={12} sm={6} md={4} lg={3} xl={2}>
                                <Card
                                    sx={{
                                        height: "100%",
                                    }}
                                >
                                    {product.imageUrls ? (
                                        <CardMedia
                                            component="img"
                                            image={imagesUrl + product.imageUrls[0] + "large.jpg"}
                                            alt={product.name}
                                            sx={{
                                                "&:hover": {
                                                    color: "red",
                                                },
                                            }}
                                        />
                                    ) : (
                                        <ChairAltIcon
                                            sx={{
                                                height: "245.4px",
                                                width: "327.2px",
                                                color: "#8c8c8c",
                                            }}
                                        />
                                    )}

                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div">
                                            {product.name}
                                        </Typography>

                                        <RowWrapper>
                                            <Typography
                                                sx={{ fontFamily: "'Poppins', sans-serif" }}
                                                fontWeight={600}
                                                fontSize={12}
                                                color="#8c8c8c"
                                            >
                                                Company:
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: "'Poppins', sans-serif",
                                                }}
                                                fontSize={12}
                                                fontWeight={"600"}
                                            >
                                                {companyMap[product.companyId] || "-"}
                                            </Typography>
                                        </RowWrapper>
                                        <RowWrapper>
                                            <Typography
                                                sx={{ fontFamily: "'Poppins', sans-serif" }}
                                                fontWeight={600}
                                                fontSize={12}
                                                color="#8c8c8c"
                                            >
                                                Inventory:
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: "'Poppins', sans-serif",
                                                }}
                                                fontSize={12}
                                                fontWeight={"600"}
                                            >
                                                {inventoryMap[product.inventoryId] || "-"}
                                            </Typography>
                                        </RowWrapper>
                                        {product.address && (
                                            <RowWrapper>
                                                <Typography
                                                    sx={{ fontFamily: "'Poppins', sans-serif" }}
                                                    fontWeight={600}
                                                    fontSize={12}
                                                    color="#8c8c8c"
                                                >
                                                    Address:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                    }}
                                                    fontSize={12}
                                                    fontWeight={"600"}
                                                >
                                                    {product.address}
                                                </Typography>
                                            </RowWrapper>
                                        )}
                                        {product.avalible && (
                                            <RowWrapper>
                                                <Typography
                                                    sx={{ fontFamily: "'Poppins', sans-serif" }}
                                                    fontWeight={600}
                                                    fontSize={12}
                                                    color="#8c8c8c"
                                                >
                                                    Available from date:
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                    }}
                                                    fontSize={12}
                                                    fontWeight={"600"}
                                                >
                                                    {product.avalible}
                                                </Typography>
                                            </RowWrapper>
                                        )}
                                    </CardContent>
                                    <CardActions>
                                        <SoecoButton
                                            color={"primary"}
                                            disabled={employeeQuery?.data?.email === undefined}
                                            onClick={() => {
                                                if (!employeeQuery?.data?.email) return;
                                                handleSendEmail(employeeQuery.data.email, product);
                                            }}
                                            sx={{
                                                position: "sticky",
                                                bottom: 0,
                                                "&:hover": { color: "#fed42a", opacity: 2 },
                                            }}
                                            aria-label={`I'm interested in ${
                                                product.name ?? "this product"
                                            } `}
                                        >
                                            I'm interested
                                        </SoecoButton>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Grid
                            container
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                            }}
                        >
                            The products does not have connecting emails to them. Sending interest
                            request is not possible.
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseAddEmailDialog}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddEmailDialog;
function isValidForm() {
    throw new Error("Function not implemented.");
}
